import { Platform } from "react-native";
import * as ImagePicker from "expo-image-picker";
import toast from "./toast";

export const checkIfTypeAccepted = (uri: string) => {
  const acceptedTypes = ["png", "jpg", "jpeg", "gif"];
  let fileExtension: string;
  if (Platform.OS === "web") {
    const regex = /image\/(png|jpg|jpeg|gif);/;
    const matchedFileExtension = uri.match(regex);
    if (matchedFileExtension === null) {
      // if file uploaded does not meet file type requirement
      return false;
    } else {
      fileExtension = matchedFileExtension[1]; // file extension is in index 1
    }
  } else {
    const dotIndex = uri.lastIndexOf(".");
    fileExtension = uri.substring(dotIndex + 1);
  }

  return acceptedTypes.includes(fileExtension);
};

export const getImageLibraryPermission = async () => {
  let permissionResult =
    await ImagePicker.requestMediaLibraryPermissionsAsync();

  if (permissionResult.granted === false) {
    toast.error("Permission to access camera roll is required!");
    return;
  }
};

export const ImagePickerOptions: ImagePicker.ImagePickerOptions = {
  mediaTypes: ImagePicker.MediaTypeOptions.Images,
  allowsEditing: true,
  aspect: [4, 3],
  quality: 0.5,
};
export const options = ["Take Photo", "Choose From Library", "Cancel"];
export const cancelButtonIndex = 2;

export const pickImageWithouActionSheet = async (
  callback: (uri: string) => void
) => {
  const pickerResult = await ImagePicker.launchImageLibraryAsync(
    ImagePickerOptions
  );
  if (pickerResult.canceled === false) {
    const fileAccepted = checkIfTypeAccepted(pickerResult.assets[0].uri);
    if (fileAccepted) {
      callback(pickerResult.assets[0].uri);
    } else {
      toast.info(
        "Unspported file. Supported file types are: .png, .jpg, .jpeg and .gif and the maximum file size is 5 MB"
      );
    }
  }
};

export const actionSheetHandler = async (
  callback: (uri: string) => void,
  buttonIndex: number | undefined
) => {
  await getImageLibraryPermission();
  if (buttonIndex === 2) return;
  let pickerResult =
    buttonIndex === 0
      ? await ImagePicker.launchCameraAsync(ImagePickerOptions)
      : await ImagePicker.launchImageLibraryAsync(ImagePickerOptions);

  if (pickerResult?.canceled !== true) {
    const typeAccepted = checkIfTypeAccepted(pickerResult.assets[0].uri);
    if (typeAccepted) {
      callback(pickerResult.assets[0].uri);
    } else {
      toast.info(
        "Unspported file. Supported file types are: .png, .jpg, .jpeg and .gif and the maximum file size is 5 MB"
      );
    }
  }
};
